import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";

export async function logindata(data) {
  try {
    return await axios
      .post(`${baseUrl}/login`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function branchmaster() {
  try {
      return await axios
          .get(`${baseUrl}/branchmaster`)
          .then((response) => {
              return response.data;
          })
          .catch((error) => {
              catcherror(error);
          });
  } catch (error) {
      catcherror(error);
  }
}


export async function saveuser(data) {
  try {
      return await axios
          .post(`${baseUrl}/usersave`,data)
          .then((response) => {
              return response.data;
          })
          .catch((error) => {
              catcherror(error);
          });
  } catch (error) {
      catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
